// extracted by mini-css-extract-plugin
module.exports = {"users-page":"UserListPage_users-page__2HQIc","page-content":"UserListPage_page-content__39EMG","no-user":"UserListPage_no-user__3JfnM"};